export const columnIsSelected = ({ columnID, columns }) =>
  (columns.find(item => item.id === columnID) || {}).selected;
